import * as React from "react";
import { styled } from "@mui/material/styles";
// import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Typography from "@mui/material/Typography";

import {
  DataGrid,
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  //   ExportCsv,
  //   ExportPrint,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
  //   GridToolbar,
  GridFilterPanel,
} from "@mui/x-data-grid";
// import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import FilterListIcon from "@mui/icons-material/FilterList";
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import MenuItem from '@mui/material/MenuItem';
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import { Statuses } from "./constant";
// import Typography from "@mui/material/Typography";
// import { useNavigate } from "react-router-dom";
// import { UserRoles, Statuses } from "../../components/common/constant";
function CustomToolbar({ bulkDelete, onApproveAll, showSelectAll }) {
  //   const [exportMenuOpen, setExportMenuOpen] = React.useState(false);
  //   const exportMenuTriggerRef = React.useRef(null);
  const StyledQuickFilter = styled(QuickFilter)({
    display: "grid",
    alignItems: "center",
  });
  const StyledToolbarButton = styled(ToolbarButton)(
    ({ theme, ownerState }) => ({
      gridArea: "1 / 1",
      width: "min-content",
      height: "min-content",
      zIndex: 1,
      opacity: ownerState.expanded ? 0 : 1,
      pointerEvents: ownerState.expanded ? "none" : "auto",
      transition: theme.transitions.create(["opacity"]),
    })
  );

  const StyledTextField = styled(TextField)(({ theme, ownerState }) => ({
    gridArea: "1 / 1",
    overflowX: "clip",
    width: ownerState.expanded ? 260 : "var(--trigger-width)",
    opacity: ownerState.expanded ? 1 : 0,
    transition: theme.transitions.create(["width", "opacity"]),
  }));
  return (
    <Toolbar
      variant="dense"
      disableGutters
      sx={
        {
          // '@media (min-width: 600px)': {
          //    minHeight: '70px',
          // },
          // minHeight: '70px',
          // marginLeft: "10px",
          // marginTop: "10px"
        }
      }
    >
      {showSelectAll && (
        <Tooltip sx={{ flex: "1 1 100%" }} title={"Delete selected user(s)"}>
          <Button
            variant="contained"
            className="justifyStart btn btn-primary"
            size="medium"
            style={{ minHeight: "auto" }}
            onClick={onApproveAll}
            sx={{ marginRight: 2, textTransform: "none" }}
            disabled={!bulkDelete}
          >
            Delete selected user(s)
          </Button>
        </Tooltip>
      )}

      {showSelectAll && (
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ mx: 0.5 }}
        />
      )}

      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>

      <Tooltip title="Filters">
        <FilterPanelTrigger
          render={(props, state) => (
            <ToolbarButton {...props} color="default">
              <Badge
                badgeContent={state.filterCount}
                color="primary"
                variant="dot"
              >
                <FilterListIcon fontSize="small" />
              </Badge>
            </ToolbarButton>
          )}
        />
      </Tooltip>

      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        sx={{ mx: 0.5 }}
      />

      <StyledQuickFilter>
        <QuickFilterTrigger
          render={(triggerProps, state) => (
            <Tooltip title="Search" enterDelay={0}>
              <StyledToolbarButton
                {...triggerProps}
                ownerState={{ expanded: state.expanded }}
                color="default"
                aria-disabled={state.expanded}
              >
                <SearchIcon fontSize="small" />
              </StyledToolbarButton>
            </Tooltip>
          )}
        />
        <QuickFilterControl
          render={({ ref, ...controlProps }, state) => (
            <StyledTextField
              {...controlProps}
              ownerState={{ expanded: state.expanded }}
              inputRef={ref}
              aria-label="Search"
              placeholder="Search..."
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: state.value ? (
                    <InputAdornment position="end">
                      <QuickFilterClear
                        edge="end"
                        size="small"
                        aria-label="Clear search"
                        material={{ sx: { marginRight: -0.75 } }}
                      >
                        <CancelIcon fontSize="small" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ) : null,
                  ...controlProps.slotProps?.input,
                },
                ...controlProps.slotProps,
              }}
            />
          )}
        />
      </StyledQuickFilter>
    </Toolbar>
  );
}

function CustomPagination({ rowCount = 0, page, pageSize, onPageChange }) {
  const pageCount = Math.ceil(rowCount / pageSize) || 1;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      <Typography variant="body2">
        {rowCount > 0
          ? `Showing ${page * pageSize + 1} to ${Math.min(
              (page + 1) * pageSize,
              rowCount
            )} of ${rowCount} results`
          : "No results"}
      </Typography>

      <Pagination
        count={pageCount}
        page={page + 1} // DataGrid is 0-based, Pagination is 1-based
        onChange={(event, value) => onPageChange(value - 1)}
        color="primary"
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{
              previous: () => <>Previous</>,
              next: () => <>Next</>,
            }}
          />
        )}
      />
    </Box>
  );
}

const gridStyles = {
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#E0E0E0", // 🔵 Deep blue header
    color: "#212121", // ⚪ White text
    fontWeight: "bold",
    fontSize: "0.95rem",
  },
  // Optional: Add border or shadow for extra flair
  //   "& .MuiDataGrid-columnHeader": {
  //     borderRight: "1px solid #e0e0e0",
  //   },

  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "#F3F3F5",
    borderBottom: "1px solid #E5E7EB",
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #E5E7EB",
  },
  "& .MuiDataGrid-row": {
    color: "#18181B",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    verticalAlign: "middle",
  },
};

export default function NewDynamicTable(props) {
  const [userList, setUserList] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const {
    tableData,
    columnsValue,
    showSelectAll,
    handleCheckBoxSelection,
    pageSize,
    pageSizeOptions,
  } = props;

  React.useEffect(() => {
    // const payload = tableData?.map((item, index) => {
    //   return {
    //     id: index + 1,
    //     ...item,
    //   };
    // });
    setUserList(tableData);
    //setSelectedRows([]);
  }, [tableData]);


  // const isToolbarSelectRef = React.useRef(false);

  const bulkDelete = selectedRows.length > 1;

  //   console.log("selectedRows", selectedRows);

  // Synchronize DataGrid selection with custom logic
  const handleSelectionModelChange = (newSelection) => {
    const selectionArray = Array.isArray(newSelection)
      ? newSelection
      : Array.from(newSelection?.ids ?? []);
    setSelectedRows(selectionArray);
  };
  const paginatedRows = userList?.slice(
    page * pageSize,
    page * pageSize + pageSize
  );

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        rows={paginatedRows}
        loading = {!paginatedRows}
        columns={columnsValue}
        getRowId={(row) => row.id}
        getRowClassName={(params) => {
                    let classes = "";
                    if (props.module === "actionPlan" && params.row.status === "Completed") {
                      classes += "action-plan-completed";
                    }
                    if ((props.module === "Inspections" || props.module === "AdminInProgress" || props.module === "ongoingInspections") && params.row.isOverDue && params.row.status !== Statuses.COMPLETED && params.row.status !== Statuses.CANCELLED) {
                      classes += " row-overdue";
                    }
                    return classes;
                  }}
        rowHeight={45}
        columnHeaderHeight={45}
        checkboxSelection={showSelectAll}
        selectionModel={selectedRows}
        onRowSelectionModelChange={handleSelectionModelChange}
        disableRowSelectionOnClick
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
          filterPanel: {
            placement: "bottom-start", // 👈 forces the panel to drop under the clicked column
            disablePortal: true, // 👈 keeps it inside the grid instead of body
          },
        }}
        slots={{
          // filterPanel: GridFilterPanel,
          filterPanel: GridFilterPanel,
          toolbar: () => (
            <CustomToolbar
              bulkDelete={bulkDelete}
              onApproveAll={() => handleCheckBoxSelection(selectedRows)}
              showSelectAll={showSelectAll}
            />
          ),
        }}
        pageSize={pageSize || 10}
        pageSizeOptions={
          pageSizeOptions || [5, 10, 20, { value: -1, label: "All" }]
        }
        sx={{
          display: "grid",
          boxShadow: 2,
          width: "100%",
          borderRadius: 1,
          ...gridStyles,
          "& .row-overdue": {
              backgroundColor: "#E520201A !important",
              "& td": {
                backgroundColor: "#E520201A !important",
              },
            },
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: pageSize || 10 } },
        }}
      />
      <CustomPagination
        rowCount={userList?.length}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
      />
    </Box>
  );
}
